import { render, staticRenderFns } from "./AcademyIndex.vue?vue&type=template&id=53a3a59d&scoped=true&"
import script from "./AcademyIndex.vue?vue&type=script&lang=js&"
export * from "./AcademyIndex.vue?vue&type=script&lang=js&"
import style0 from "./AcademyIndex.vue?vue&type=style&index=0&id=53a3a59d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3a59d",
  null
  
)

export default component.exports